import React from "react";
import { API } from "../context/AppContext";
import GeoArt from "./GeoArt";

export default function ImageOrArt({ image, seed, className = "", ratio = "4/5", alt = "Artwork" }) {
  if (image) {
    return (
      <img
        src={`${API}/files/${image}`}
        alt={alt}
        loading="lazy"
        className={className}
        style={{ aspectRatio: ratio, objectFit: "cover", width: "100%", display: "block" }}
      />
    );
  }
  return <GeoArt seed={seed} className={className} ratio={ratio} />;
}
